// feito por dev: O ESTAGIÁRIO
export const whatsappNumber = process.env.NEXT_PUBLIC_WHATSAPP_NUMBER ?? ''

export function whatsappUrl(message = 'Olá, preciso de ajuda na plataforma Outro Ângulo.') {
  return whatsappNumber ? `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}` : '/contato'
}
